import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import chairTaiChiMWebp from '@/assets/landing/chair-tai-chi-m.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('activity-male-chair-tai-chi.landing.loader.title'),
			size: 'small',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: chairTaiChiMWebp,
			customStyles: {
				width: 'calc(100% + 40px)',
				maxWidth: 'none',
				marginLeft: '-20px',
				marginRight: '-20px',
				marginTop: 'var(--size-24)',
				marginBottom: 'var(--size-24)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
